const BaseModule = require('../../../90_utils/base/BaseModule');

class CEOHero extends BaseModule {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }

	_removeListeners(){ }

	//

	_show(){

		let $lines = this.$el.find('.overline, .underline');

		TweenMax.set($lines, { scaleX: 0, transformOrigin: 'center' });

		TweenMax.staggerTo($lines, 0.4, {
			scaleX: 1,
			ease: 'progressSlide'
		}, 0.2);
	}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }

	_resize(){ }
}

module.exports = CEOHero;
